module.exports = __webpack_public_path__ + "static/media/try-twaming-platform.974246ad.jpg";